import { useDispatch } from "react-redux";
import {
  nextStep,
  updateField,
} from "../../../store/reducers/users/usersForm.slice";
import { generatePassword } from "../../../utils/passwordGenerator";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";

const StepAccount = () => {
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors, isValid },
  } = useForm({ mode: "onChange" });

  const onSubmit = (data) => {
    Object.entries(data).forEach(([name, value]) => {
      dispatch(updateField({ name, value }));
    });
    dispatch(nextStep());
  };

  const autoPassword = () => {
    const pwd = generatePassword(10);

    setValue("password", pwd, { shouldValidate: true });
    setValue("password2", pwd, { shouldValidate: true });

    dispatch(updateField({ name: "password", value: pwd }));
    dispatch(updateField({ name: "password2", value: pwd }));
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="vstack gap-3">
      <div className="vstack gap-3">
        <div className="form-floating">
          <input
            className={`form-control ${errors.username ? "is-invalid" : ""}`}
            placeholder="Usuario"
            {...register("username", { required: "El usuario es requerido" })}
          />
          <label>Usuario</label>
          {errors.username && (
            <div className="invalid-feedback">{errors.username.message}</div>
          )}
        </div>

        <div className="form-floating">
          <input
            className={`form-control ${errors.email ? "is-invalid" : ""}`}
            placeholder="Email"
            {...register("email", {
              required: "El email es requerido",
              pattern: {
                value: /^\S+@\S+$/i,
                message: "Email no válido",
              },
            })}
          />
          <label>Email</label>
          {errors.email && (
            <div className="invalid-feedback">{errors.email.message}</div>
          )}
        </div>

        <div className="form-floating">
          <input
            type={showPassword ? "text" : "password"}
            className={`form-control ${errors.password ? "is-invalid" : ""}`}
            placeholder="Password"
            {...register("password", {
              required: "La contraseña es requerida",
              minLength: {
                value: 8,
                message: "Mínimo 8 caracteres",
              },
            })}
          />
          <label>Password</label>
          <span
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: "absolute",
              right: "15px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              zIndex: 10,
            }}
          >
            <Icon icon={showPassword ? "mdi-light:eye-off" : "mdi-light:eye"} width="22" />
          </span>
          {errors.password && (
            <div className="invalid-feedback">{errors.password.message}</div>
          )}
        </div>

        <div className="form-floating">
          <input
            type={showPassword2 ? "text" : "password"}
            className={`form-control ${errors.password2 ? "is-invalid" : ""}`}
            placeholder="Confirmar password"
            {...register("password2", {
              required: "Confirma la contraseña",
              validate: (value) =>
                value === getValues("password") ||
                "Las contraseñas no coinciden",
            })}
          />
          <label>Confirmar password</label>
          <span
            onClick={() => setShowPassword2(!showPassword2)}
            style={{
              position: "absolute",
              right: "15px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              zIndex: 10,
            }}
          >
            <Icon icon={showPassword2 ? "mdi-light:eye-off" : "mdi-light:eye"} width="22" />
          </span>
          {errors.password2 && (
            <div className="invalid-feedback">{errors.password2.message}</div>
          )}
        </div>

        <div className="form-floating">
          <select
            className={`form-select ${errors.rol ? "is-invalid" : ""}`}
            defaultValue=""
            {...register("rol", { required: "El rol es obligatorio" })}
          >
            <option value="" disabled>
              Rol del usuario
            </option>
            <option value="ADMIN SYS">Administrador global</option>
            <option value="MENTOR">Mentor</option>
            <option value="ESTUDIANTE">Estudiante</option>
            <option value="ADMIN_ESCOLAR">Auxiliar de control escolar</option>
          </select>
          <label>Rol</label>
          {errors.rol && (
            <div className="invalid-feedback">{errors.rol.message}</div>
          )}
        </div>

        <div className="d-flex justify-content-between">
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={autoPassword}
          >
            Generar contraseña
          </button>

          <button type="submit" className="btn btn-primary" disabled={!isValid}>
            Siguiente
          </button>
        </div>
      </div>
    </form>
  );
};

export default StepAccount;
